import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[appIndeterminate]',
    standalone: false
})
export class IndeterminateCheckboxDirective {
  @Input()
  set appIndeterminate(value) {
    if (value === 'indeterminate') {
      this.elem.nativeElement.indeterminate = true;
    } else if (value === 'checked') {
      this.elem.nativeElement.indeterminate = false;
      this.elem.nativeElement.checked = true;
    } else {
      this.elem.nativeElement.checked = false;
      this.elem.nativeElement.indeterminate = false;
    }
  }

  constructor(private elem: ElementRef) { }

}
